import request from "@/utils/request";

// 评价类别/项目-新增指标
export const addEvaluationTarget = (data) => {
  return request({
    url: "/evaluationTarget/addEvaluationTarget",
    method: "POST",
    data,
  });
};

// 评价等级层次-新增等级层次
export const addEvaluationTargetLevel = (data) => {
  return request({
    url: "/evaluationTarget/addEvaluationTargetLevel",
    method: "POST",
    data,
  });
};

// 评价类别/项目-删除指标
export const deleteEvaluationTarget = (data) => {
  return request({
    url: "/evaluationTarget/deleteEvaluationTarget",
    method: "POST",
    data,
  });
};

// 评价等级层次-删除等级层次
export const deleteEvaluationTargetLevel = (data) => {
  return request({
    url: "/evaluationTarget/deleteEvaluationTargetLevel",
    method: "POST",
    data,
  });
};

// 评价类别/项目-编辑指标
export const editEvaluationTarget = (data) => {
  return request({
    url: "/evaluationTarget/editEvaluationTarget",
    method: "POST",
    data,
  });
};

// 评价等级层次-编辑等级层次
export const editEvaluationTargetLevel = (data) => {
  return request({
    url: "/evaluationTarget/editEvaluationTargetLevel",
    method: "POST",
    data,
  });
};

// 评价类别/项目-查询指标
export const queryEvaluationTarget = (data) => {
  return request({
    url: "/evaluationTarget/queryEvaluationTarget",
    method: "POST",
    data,
  });
};

// 评价等级层次-查询等级层次
export const queryEvaluationTargetLevel = (data) => {
  return request({
    url: "/evaluationTarget/queryEvaluationTargetLevel",
    method: "POST",
    data,
  });
};
